<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" class="u-text-white" />

                <div class="page-block">
                    <technical-management-tabs :step="2" :domain="domain" />

                    <div class="page-block__item-wrapper">{{ trans('order.no-information') }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderPartial, serviceMixin, servicesPageMixin } from 'relapp-technical-management';
import TechnicalManagementTabs from '@/components/technical-management/TechnicalManagementTabs.vue';

export default {
    components: {
        HeaderPartial,
        TechnicalManagementTabs
    },
    mixins: [serviceMixin, servicesPageMixin],
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'extension'
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.getServices();
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.domain.title', { domain: this.domain })
        };
    }
};
</script>
